<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="form-section">
        <i class="ft-repeat"></i> Pre Shared Key (PSK) for user {{ currentObject.FullName }}</h4>
    </div>
    <div class="card-body">
      <div class="px-3">

        <!-- PreSharedKey -->
        <div class="card-field">
          <div class="card-field-label">Pre Shared Key:</div>
          <div class="card-field-content">{{ currentObject.PreSharedKey }}</div>
        </div>
        <br>

        <div class="form-actions">
          <button [disabled]="hasInvalidPreSharedKey" disabledtype="button" class="btn btn-primary btn-raised mr-1"
                  (click)="copyPresharedKey(currentObject.PreSharedKey)" title="Copy pre shared key to the clipboard">
            <i class="ft-copy"> Copy </i>
          </button>
          <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
            <i class="ft-x-square"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
